import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import moment from 'moment-timezone'
import {
  HAUL_TYPE,
  HAUL_TYPE_OPTIONS,
  APPOINTMENT_TIME_OPTIONS,
  APPOINTMENT_TYPE,
} from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IAppointmentTimeProps {
  value: RecursivePartial<ISpotBiddingRule>
  type?: string
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  error?: string
}

export const AppointmentTime = memo<IAppointmentTimeProps>(({ error, onChange, type, value }) => {
  const { mileageCriteria = {}, appointmentTimeCriteria = {} } = value || {}
  const { rangeEnd = '200', rangeStart = '0' } = mileageCriteria || {}
  const { deliveryRangeEnd, deliveryRangeStart, pickupRangeEnd, pickupRangeStart } =
    appointmentTimeCriteria || value || {}
  const appointmentType =
    pickupRangeStart || type === 'pickup' ? APPOINTMENT_TYPE.PICKUP : APPOINTMENT_TYPE.DELIVERY
  const haulType = rangeStart && !rangeEnd ? HAUL_TYPE.NON_LOCAL : HAUL_TYPE.LOCAL
  const timezoneValue = appointmentTimeCriteria.timezoneOverride || ''
  const timezones = moment.tz.zonesForCountry('US').map(x => ({
    label: x,
    value: x,
  }))
  const appointmentValue =
    appointmentType === APPOINTMENT_TYPE.PICKUP
      ? `${pickupRangeStart}-${pickupRangeEnd}`
      : `${deliveryRangeStart}-${deliveryRangeEnd}`

  const timezonesHandler = (e: ISelectOption<string>) => {
    onChange({
      appointmentTimeCriteria: {
        ...appointmentTimeCriteria,
        timezoneOverride: e.value,
      },
    })
  }
  const haulTypeHandler = (e: ISelectOption<string>) => {
    switch (e.value) {
      case HAUL_TYPE.NON_LOCAL: {
        onChange({
          mileageCriteria: {
            ...mileageCriteria,
            rangeStart: '200',
            rangeEnd: '',
          },
        })
        break
      }
      case HAUL_TYPE.LOCAL: {
        onChange({
          mileageCriteria: {
            ...mileageCriteria,
            rangeStart: '0',
            rangeEnd: '200',
          },
        })
        break
      }
      default:
    }
  }

  const appointmentTimeHandler = (e: ISelectOption<string>) => {
    const { value: appointmentTime = '' } = e || {}
    const [appointmentStart, appointmentEnd] = appointmentTime.split('-') || []

    const update = {
      mileageCriteria: {
        rangeStart,
        rangeEnd,
      },
      appointmentTimeCriteria: {},
    }
    if (pickupRangeStart || type === APPOINTMENT_TYPE.PICKUP) {
      update.appointmentTimeCriteria = {
        pickupRangeStart: appointmentStart,
        pickupRangeEnd: appointmentEnd,
        deliveryRangeStart: undefined,
        deliveryRangeEnd: undefined,
      }
    } else {
      update.appointmentTimeCriteria = {
        pickupRangeStart: undefined,
        pickupRangeEnd: undefined,
        deliveryRangeStart: appointmentStart,
        deliveryRangeEnd: appointmentEnd,
      }
    }

    onChange(update)
  }

  return (
    <>
      {!type && (
        <div className='col-md-6 col-xs-4'>
          <Select
            label='Type of Haul'
            placeholder='Choose an option'
            options={HAUL_TYPE_OPTIONS}
            value={haulType}
            onChange={haulTypeHandler}
            dataTest='modal-haul-type-option'
            required
            large
          />
        </div>
      )}
      <div className='col-md-6 col-xs-4'>
        <Select
          label='Appointment Time'
          placeholder='Choose an option'
          options={APPOINTMENT_TIME_OPTIONS[appointmentType][haulType]}
          value={appointmentValue}
          onChange={appointmentTimeHandler}
          dataTest='modal-appointment-time-option'
          validationMessage={error}
          invalid={!!error}
          required
          large
        />
      </div>
      <div className='col-md-6 col-xs-4'>
        <Select
          label='Timezone'
          placeholder='Choose an option'
          options={timezones}
          value={timezoneValue}
          onChange={timezonesHandler}
          dataTest='modal-appointment-timezone-option'
          large
        />
      </div>
    </>
  )
})
